import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";

type Props = { id: string; name: string; accept: string };

export function ImageInput({ id, name, accept }: Props) {
  const { t } = useTranslation();
  const input = useRef<HTMLInputElement>(null);
  const [filename, setFilename] = useState("");
  return (
    <div className="flex flex-wrap items-center gap-2">
      <input
        ref={input}
        id={id}
        name={name}
        type="file"
        accept={accept}
        className="sr-only"
        tabIndex={-1}
        onChange={(event) => setFilename(event.target.files?.[0]?.name || "")}
      />
      <Button
        type="button"
        variant="outline"
        onClick={() => input.current?.click()}
      >
        {t("profile_ui.choose_image")}
      </Button>
      <span
        className="text-muted-foreground min-w-0 break-all text-sm"
        aria-live="polite"
      >
        {filename || t("profile_ui.no_image")}
      </span>
    </div>
  );
}
